export const UPDATE_USER_ONLINE = 1 * 1000 // 1s
export const VERIFY_USER_SESSION = 1 * 1000 // 1s
export const UPDATE_LOGGED_ENTITY_INTERVAL = 90 * 1000
export const UPDATE_INFORMACOES_ADICIONAIS = 60 * 1000
export const UPDATE_INFORMACOES_ADICIONAIS_ADMIN = 3 * 60 * 1000
export const UPDATE_EXAMES_LIST = 30 * 1000
export const UPDATE_CONSULTA_LIST = 30 * 1000
